var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79999 20.4272C5.79999 20.4272 -0.0404024 36.6505 10.3691 35.21C20.7785 33.7695 35.9869 44.9436 37.6576 31.3342C39.3302 17.7248 36.7894 5.37545 31.4178 4.11361C26.0462 2.85178 12.6436 -0.277939 5.79999 20.4272Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 7.83398V9.16732M8.66683 21.1673H7.3335M12.0002 12.5007L11.2 11.7005M29.3335 12.5007L30.1338 11.7005M34.0002 21.1673H32.6668M25.3335 27.6659C27.3523 26.2137 28.6668 23.844 28.6668 21.1673C28.6668 16.749 25.0851 13.1673 20.6668 13.1673C16.2486 13.1673 12.6668 16.749 12.6668 21.1673C12.6668 23.844 13.9814 26.2137 16.0002 27.6659V30.234C16.0002 31.7275 16.0002 32.4742 16.2908 33.0446C16.5465 33.5464 16.9544 33.9543 17.4562 34.21C18.0266 34.5007 18.7734 34.5007 20.2668 34.5007H21.0668C22.5603 34.5007 23.307 34.5007 23.8775 34.21C24.3792 33.9543 24.7872 33.5464 25.0428 33.0446C25.3335 32.4742 25.3335 31.7275 25.3335 30.234V27.6659Z",
    stroke: "url(#paint0_linear_1786_44867)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7704 24.542C19.8704 24.4487 19.9738 24.362 20.0804 24.282C20.1871 24.202 20.3004 24.1353 20.4204 24.082C20.5438 24.0253 20.6754 23.982 20.8154 23.952C20.9588 23.9187 21.1138 23.902 21.2804 23.902C21.5638 23.902 21.8138 23.952 22.0304 24.052C22.2504 24.1487 22.4354 24.2853 22.5854 24.462C22.7354 24.6353 22.8488 24.8437 22.9254 25.087C23.0021 25.327 23.0404 25.5887 23.0404 25.872V29.167H21.4904V25.872C21.4904 25.6187 21.4321 25.422 21.3154 25.282C21.1988 25.1387 21.0271 25.067 20.8004 25.067C20.6304 25.067 20.4704 25.1037 20.3204 25.177C20.1738 25.247 20.0304 25.3437 19.8904 25.467V29.167H18.3404V23.982H19.3004C19.4938 23.982 19.6204 24.0687 19.6804 24.242L19.7704 24.542Z",
    fill: "url(#paint1_linear_1786_44867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44867",
    x1: 7.3335,
    y1: 7.83398,
    x2: 33.9977,
    y2: 34.5031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_44867",
    x1: 17.667,
    y1: 20.167,
    x2: 26.4905,
    y2: 25.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.d50851048fc6415dde9a7b2b1e90f633.svg";
export { ForwardRef as ReactComponent };